module.exports = __webpack_public_path__ + "static/banner-bloco1-87938d5a73c1597aa9501bcbe7d2b54c.png";